var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContestArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3145_2419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.83303 7.55728L10.5082 0.88221C10.6626 0.727699 10.8687 0.642578 11.0885 0.642578C11.3082 0.642578 11.5143 0.727699 11.6687 0.88221L12.1603 1.37367C12.4802 1.69391 12.4802 2.21439 12.1603 2.53415L6.55496 8.13947L12.1665 13.751C12.3209 13.9055 12.4061 14.1115 12.4061 14.3311C12.4061 14.551 12.3209 14.757 12.1665 14.9116L11.6749 15.4029C11.5204 15.5575 11.3144 15.6426 11.0947 15.6426C10.8749 15.6426 10.6688 15.5575 10.5144 15.4029L3.83303 8.72178C3.67827 8.56678 3.59327 8.35983 3.59376 8.13983C3.59327 7.91898 3.67827 7.71215 3.83303 7.55728Z",
    fill: "#A0A3B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3145_2419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "matrix(-1 0 0 1 15.5 0.642578)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContestArrow);
export default __webpack_public_path__ + "static/media/contest_arrow.86e56c2cb469bafdf1d3a810660daa23.svg";
export { ForwardRef as ReactComponent };